import type { FC, ReactNode } from "react";
import { Navigate, useLocation } from "react-router";
import { useAuth } from "../hooks/useAuth";
import { isDataUser, isDataUserAllowedPath } from "./roles";

/**
 * Deny-by-default route allowlist for restricted roles, mounted once in
 * DashboardLayout so every present AND future child route is covered without
 * per-route wiring. A data user is redirected to /data from anywhere else.
 *
 * While WhoAmI is still loading (`user` null) the content renders unguarded for
 * a moment — same pattern as AdminView's self-guard — which leaks nothing: every
 * resolver behind those pages already denies DATA_USER server-side.
 */
export const RoleGuard: FC<{ children: ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();
  if (isDataUser(user) && !isDataUserAllowedPath(location.pathname)) {
    return <Navigate to="/data" replace />;
  }
  return <>{children}</>;
};
